import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { InlineWidget } from "react-calendly";

function Calendly() {
  return (
    <>
      {/* <div className="calendly-inline-widget" data-url="https://calendly.com/orangedrivers/online-beratungstermin?primary_color=009fe3" style={{minWidth: 320 + 'px', height: 850 + 'px', width: 100 + '%'}}></div> */}
      <InlineWidget url="https://calendly.com/orangedrivers/online-beratungstermin?primary_color=009fe3" styles={{minWidth: 320 + 'px', height: 850 + 'px', width: 100 + '%'}} />
    </>
  );
}

const Beratung = () => {
  return (
      <div>
        {/* <Helmet>
          <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js"></script>
        </Helmet> */}
        
        {/* <div className="static-page-title">
          <h1 style={{ textAlign: "center" }}>Beratungstermin buchen</h1>
        </div> */}
        <div className="calendly-wrapper">
          <Calendly />
          {/* <div className="calendly-inline-widget" data-url="https://calendly.com/orangedrivers/online-beratungstermin?primary_color=009fe3" style={{minWidth: 320 + 'px', height: 850 + 'px', width: 100 + '%'}}></div> */}
        </div>
      </div>
  );
};

export default Beratung;
